<template>
  <div :class="[onTop ? 'topContainer' : '']">
    <div class="v-model" v-show="show"></div>
    <transition name="dialog-fade">
      <div class="ai-message-box__wrapper" v-show="show">
        <div class="ai-message-box">
          <div class="ai-message-box__close el-dialog__close el-icon el-icon-close" v-if="showClose" @click="handleCancle('close')"></div>
          <div class="ai-message-box__header">
            <div class="el-icon-warning"></div><span>{{ title }}</span>
          </div>
          <div class="ai-message-box__content">
            <div class="ai-message-box__message"><p>{{ message }}</p></div>
          </div>
          <div class="ai-message-box__btns">
            <div class="ai-message-box__lf"><el-checkbox v-if="cbkConfig.isShow" circle v-model="cbkConfig.status">{{ cbkConfig.txt }}</el-checkbox></div>
            <div class="ai-message-box__rgt">
              <el-button size="small" v-if="showCancleBtn" @click="handleCancle('cancle')">{{ cancelButtonText }}</el-button>
              <el-button size="small" @click="handleSubmit" type="primary">{{ confirmButtonText }}</el-button>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>
<script>
/* eslint-disable */
export default {
  data() {
    return{
      message: '',
      title: '提示',
      cbkConfig: {
        status: false,
        isShow: false,  // 是否展示选中框
        txt: '选中'
      },
      cancelButtonText: '取消',
      confirmButtonText: '确定',
      show: false,
      submitAction: null,
      cancleAction: null,
      showClose: false,
      showCancleBtn: true,
      onTop: false
    }
  },
  watch: {
    show(val) {
      if (!val) {
        Object.assign(this.$data, this.$options.data())
      }
    }
  },
  methods: {
    handleCancle(type = 'cancle') {
      this.show = false
      this.cancleAction && this.cancleAction({ type })
    },
    handleSubmit() {
      this.submitAction && this.submitAction({ checkboxStatus: this.cbkConfig.status })
      this.show = false
    }
  }
}
</script>
<style lang="scss">
.topContainer{
  .v-model{
    z-index: 10000;
  }
  .ai-message-box__wrapper{
    z-index: 100001;
  }
}
.v-model {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  opacity: .5;
  background: #000;
  z-index: 1000;
}
.ai-message-box__wrapper{
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  text-align: center;
  z-index: 2001;
  .ai-message-box__close{
    position: absolute;
    right: 20px;
    top: 20px;
    cursor: pointer;
    &:hover{
      color: #ff8533;
    }
  }
  &:after{
    content: "";
    display: inline-block;
    height: 100%;
    width: 0;
    vertical-align: middle;
  }
  .ai-message-box {
    display: inline-block;
    width: 437px;
    padding: 32px 32px 24px;
    vertical-align: middle;
    background-color: #FFF;
    border-radius: 4px;
    border: 1px solid #EBEEF5;
    font-size: 18px;
    box-shadow:0px 4px 12px 0px rgba(0,0,0,0.2);
    text-align: left;
    overflow: hidden;
    -webkit-backface-visibility: hidden;
    backface-visibility: hidden;
    position: relative;
    .ai-message-box__header {
      font-size:16px;
      font-weight:500;
      color:rgba(0,0,0,0.85);
      display: flex;
      align-items: center;
      div{
        color: #FFD000;
        font-size: 22px;
        width: 38px;
      }
      span{
        font-size:16px;
        font-family:PingFangSC-Medium,PingFang SC;
        font-weight:500;
        color:rgba(0,0,0,0.85);
      }
    }
    .ai-message-box__content{
      font-size:14px;
      font-weight:400;
      color:rgba(0,0,0,0.65);
      line-height:22px;
      margin-left: 38px;
      margin-top: 12px;
      min-height: 54px;
    }
    .ai-message-box__btns{
      margin-left: 38px;
      margin-top: 14px;
      display: flex;
      align-items: center;
      justify-content: space-between;

    }
  }
}

</style>
